import create from "zustand";
import { persist } from "zustand/middleware";

interface State {
	focusLockDontRemindAgainAboutStudentAuth: boolean;
}

interface Actions {
	setFocusLockDontRemindAgainAboutStudentAuth: (ticked: boolean) => void;
}

/**
 * A persistent Zustand store designed for minor things that need to be persisted between sessions, such as "don't show again" options that have been ticked.
 */
export const usePersistentStore = create<State & Actions>(
	persist(
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		(set, _get) => ({
			focusLockDontRemindAgainAboutStudentAuth: false,
			setFocusLockDontRemindAgainAboutStudentAuth: (ticked: boolean) => {
				set({ focusLockDontRemindAgainAboutStudentAuth: ticked });
			},
		}),
		{
			getStorage: () => localStorage,
			name: "PERSISTENT_STORE",
		}
	)
);
